import * as PIXI from 'pixi.js';
import DraggableWallResizer from './DraggableWallResizer';

const DIAMETER = 16;
const RADIUS = DIAMETER / 2;
const HIT_AREA_RADIUS = RADIUS * 4;

export default class DragDot extends DraggableWallResizer {
  constructor({
    x,
    y,
    moveableAxes,
    ratio,
    canvasContainer,
    canvasHeight,
    prevWallSize,
    itemContainerLimits,
    wallResizerOffset,
  }) {
    super({
      moveableAxes,
      ratio,
      canvasContainer,
      canvasHeight,
      prevWallSize,
      itemContainerLimits,
      wallResizerOffset,
    });

    this.dragging = false;
    this.draggingPosition = null;
    this.prevEmittedWallSize = null;
    this.pointerOffset = { x: 0, y: 0 };

    const resource = PIXI.Loader.shared.resources['drag_dot'];
    this.texture = resource.texture;

    this.sprite && this.sprite.destroy();
    this.container && this.container.destroy();

    this.sprite = new PIXI.Sprite(this.texture);
    this.sprite.x = 0;
    this.sprite.y = 0;
    this.sprite.width = DIAMETER;
    this.sprite.height = DIAMETER;
    this.sprite.anchor.set(0.5, 0.5);

    this.container = new PIXI.Container();
    this.container.cursor = this.getHoverCursor();
    this.container.interactive = true;
    this.container.x = x;
    this.container.y = y;

    this.container.hitArea = new PIXI.Circle(0, 0, HIT_AREA_RADIUS);

    this.container.on('pointerup', this.onPointerUp);
    this.container.on('pointerupoutside', this.onPointerUp);
    this.container.on('pointermove', this.onPointerMove);
    this.container.on('pointerdown', this.onPointerDown);

    this.container.addChild(this.sprite);
  }

  update({ x, y, prevWallSize }) {
    super.update({ prevWallSize });
    this.container.x = x;
    this.container.y = y;
  }

  getHoverCursor() {
    return 'grab';
  }

  getPosition() {
    return { x: this.container.x, y: this.container.y };
  }

  getDisplayObject() {
    return this.container;
  }

  destroy() {
    this.container.off('pointermove');
    this.container.off('pointerdown');
    this.container.off('pointerup');
    this.container.off('pointerupoutside');

    this.sprite && this.sprite.destroy();
    this.container && this.container.destroy();
  }
}
